import { j as s } from "./index.es33.js";
import { Icon as o } from "./index.es7.js";
import "./index.es93.js";
import "./index.es94.js";
import "./index.es95.js";
import "./index.es96.js";
import "./index.es97.js";
import "./index.es98.js";
import "./index.es99.js";
import "./index.es100.js";
import "./index.es101.js";
import "./index.es102.js";
import "./index.es103.js";
import "./index.es104.js";
import { palette as i } from "./index.es36.js";
var u = {
  warning: {
    color: i.orange4,
    icon: s.jsx(o, {
      icon: o.icons.system.s.stateIndicators.warning,
      size: 16
    })
  },
  success: {
    color: i.green5,
    icon: s.jsx(o, {
      icon: o.icons.system.s.utilities.marked,
      size: 16,
      color: i.green5
    })
  },
  error: {
    color: i.red5,
    icon: s.jsx(o, {
      icon: o.icons.system.s.stateIndicators.error,
      size: 16
    })
  },
  info: {
    color: i.gray6,
    icon: s.jsx(o, {
      icon: o.icons.system.s.stateIndicators.information,
      size: 16
    })
  },
  message: {
    color: i.blue6,
    icon: s.jsx(o, {
      icon: o.icons.system.s.stateIndicators.speaker,
      size: 16,
      color: i.blue6
    })
  }
};
export { u as ToastKindConfig };